import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Guest } from '@/types';

interface NewGuestModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (guestData: Omit<Guest, 'id' | 'event_id'>) => void;
}

export const NewGuestModal: React.FC<NewGuestModalProps> = ({ open, onOpenChange, onSubmit }) => {
  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [estado, setEstado] = useState<'PENDIENTE' | 'CONFIRMADO' | 'RECHAZADO'>('PENDIENTE');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!nombre.trim() || !telefono.trim()) {
      return;
    }

    const newGuest: Omit<Guest, 'id' | 'event_id'> = {
      nombre: nombre.trim(),
      tel: telefono.trim(),
      estado: estado,
      fecha_respuesta: estado !== 'PENDIENTE' ? new Date() : undefined,
      numero_acompanantes: 0,
      asistencia: 'PENDIENTE',
    };

    onSubmit(newGuest);
    
    // Reset form
    setNombre('');
    setTelefono('');
    setEstado('PENDIENTE');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Agregar Nuevo Invitado</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="nombre">Nombre completo</Label>
            <Input 
              id="nombre" 
              placeholder="Ej: María García" 
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
          </div>
          <div>
            <Label htmlFor="telefono">Teléfono</Label>
            <Input 
              id="telefono" 
              placeholder="+52 55 1234 5678" 
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              required
            />
          </div>
          <div>
            <Label htmlFor="estado">Estado inicial</Label>
            <Select 
              value={estado} 
              onValueChange={(value: 'PENDIENTE' | 'CONFIRMADO' | 'RECHAZADO') => setEstado(value)}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="PENDIENTE">Pendiente</SelectItem>
                <SelectItem value="CONFIRMADO">Confirmado</SelectItem>
                <SelectItem value="RECHAZADO">Rechazado</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white">
              Agregar Invitado
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
